import styled from 'styled-components';
import {clampFunc} from '../index';
import {careerNewbieClampThreshold, careerNewbieFontSize} from '../../constant';

export const ActionButtonWrapper = styled.div`
	margin: 25px 0;
	display: none;
	@media all and (min-width: 992px) {
		display: block;
	}
`
export const Banner = {
	Wrapper: styled.div`
		display: flex;
		flex-flow: column;
		align-items: center;

		@media all and (min-width: 992px) {
			flex-flow: row;
		}
	`,
	City: styled.div`
		flex-grow: 1;
		margin-bottom: -30px;

		@media all and (min-width: 992px) {
			margin-top: 100px;
		}
		
		img {
			max-width: 600px;
			width: 100%;
			@media all and (min-width: 992px) {
				max-width: unset;
			}
		}
	`,
	Content: styled.div`
		display: inline-block;
		text-align: right;
		@media all and (min-width: 992px) {
			margin-left: auto;
			margin-right: 0;
			flex: 1 0 auto;
			margin-top: 70px;
		}
	`
}
export const Headline = styled.h1`
  color: #001644;
	font-size: ${clampFunc(careerNewbieFontSize.mobile.heading, careerNewbieClampThreshold.mobile)};
  font-weight: 800;
  letter-spacing: -0.8px;
  text-transform: uppercase;
  margin: 0;
	text-align: center;
  @media all and (min-width: 992px) {
	  text-align: left;
	  font-size: ${clampFunc(careerNewbieFontSize.desktop.heading, careerNewbieClampThreshold.desktop)};
  }

  span {
    color: #FFF
  }
`
export const Sub = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	padding: 35px 0 25px;
	top: -10px;
	
	img {
		position: absolute;
		top: 22px;
		left: -22px;
		z-index: 1;
		user-select: none;
		width: ${clampFunc({min: 50, max: 70}, careerNewbieClampThreshold.mobile)};

		@media all and (min-width: 768px) {

			top: 15px;
			left: -45px;
			width: ${clampFunc({min: 70, max: 120}, careerNewbieClampThreshold.mobile)};
		}
	}
	
	span {
		border-radius: 28.571px;
		border: 0.571px solid rgba(255, 255, 255, 0.44);
		background: linear-gradient(270deg, rgba(255, 255, 255, 0.62) -65.9%, rgba(255, 255, 255, 0.00) 160.44%);
		box-shadow: 0px 2.28571px 5.71429px 0px rgba(255, 255, 255, 0.25) inset, 0px 2.28571px 2.28571px 0px rgba(255, 255, 255, 0.10);
		backdrop-filter: blur(2.857142686843872px);
		padding: 2px 4px 2px 6vw;
		color: #fff;
		display: inline-block;
		text-shadow: 0px 2.2857141494750977px 2.2857141494750977px rgba(255, 255, 255, 0.10);
		font-weight: 700;
		font-size: ${clampFunc(careerNewbieFontSize.mobile.subHeading, careerNewbieClampThreshold.mobile)};
		flex-shrink: 0;
		
		@media all and (min-width: 768px) {
			padding: 8px 20px 8px 6vw;
		}
		
		@media all and (min-width: 992px) {
			padding: 8px 20px 8px 50px;
			font-size: ${clampFunc(careerNewbieFontSize.desktop.subHeading, careerNewbieClampThreshold.desktop)};
		}
	}
`
